import React from 'react'
import Skeleton from 'react-loading-skeleton'

const CategoryFilterSkeleton = () => {
  return (
    <div className="space-y-6">
      {/* Back button skeleton */}
      <div className="flex items-center gap-2 mb-6">
        <Skeleton
          width={20}
          height={20}
          baseColor="#f1f5f9"
          highlightColor="#e2e8f0"
          className="!rounded-sm"
        />
        <Skeleton
          width={80}
          height={16}
          baseColor="#f1f5f9"
          highlightColor="#e2e8f0"
          className="!rounded-sm"
        />
      </div>

      {/* Categories skeleton */}
      <div className="space-y-3">
        {Array(6)
          .fill()
          .map((_, index) => (
            <div key={index} className="flex items-center gap-3 p-3 rounded-lg">
              <Skeleton
                width={24}
                height={24}
                baseColor="#f8fafc"
                highlightColor="#e2e8f0"
                className="!rounded-sm"
              />
              <Skeleton
                width={`${80 + index * 10}px`}
                height={16}
                baseColor="#f1f5f9"
                highlightColor="#e2e8f0"
                className="!rounded-sm"
              />
            </div>
          ))}
      </div>

      {/* Price filter skeleton */}
      <div className="border-t border-gray-200 pt-6">
        <Skeleton
          width={100}
          height={20}
          baseColor="#f1f5f9"
          highlightColor="#e2e8f0"
          className="mb-4 !rounded-sm"
        />
        <div className="space-y-4">
          <div className="flex gap-3">
            <Skeleton
              width={80}
              height={36}
              baseColor="#f8fafc"
              highlightColor="#e2e8f0"
              className="!rounded-lg"
            />
            <Skeleton
              width={80}
              height={36}
              baseColor="#f8fafc"
              highlightColor="#e2e8f0"
              className="!rounded-lg"
            />
          </div>
          <Skeleton
            height={8}
            baseColor="#f1f5f9"
            highlightColor="#e2e8f0"
            className="!rounded-full"
          />
        </div>
      </div>

      {/* Filter sections skeleton */}
      {Array(3)
        .fill()
        .map((_, sectionIndex) => (
          <div key={sectionIndex} className="border-t border-gray-200 pt-6">
            <Skeleton
              width={120}
              height={20}
              baseColor="#f1f5f9"
              highlightColor="#e2e8f0"
              className="mb-4 !rounded-sm"
            />
            <div className="space-y-3">
              {Array(4)
                .fill()
                .map((_, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <Skeleton
                      width={16}
                      height={16}
                      baseColor="#f8fafc"
                      highlightColor="#e2e8f0"
                      className="!rounded-sm"
                    />
                    <Skeleton
                      width={`${60 + index * 15}px`}
                      height={14}
                      baseColor="#f1f5f9"
                      highlightColor="#e2e8f0"
                      className="!rounded-sm"
                    />
                  </div>
                ))}
            </div>
          </div>
        ))}

      {/* Clear filter button skeleton */}
      <div className="pt-6">
        <Skeleton
          width="100%"
          height={40}
          baseColor="#f1f5f9"
          highlightColor="#e2e8f0"
          className="!rounded-lg"
        />
      </div>
    </div>
  )
}

export default CategoryFilterSkeleton
